// import appInfo from '@/app-info'
// import axios from 'axios'
// import router from '@/router';

const emptyData = {
  SchedulerName: '',
  Period: 'daily',
  Day: 0,
  Email: '',
  Subject: '',
  Message: '',
  ModifiedBy: '',
  ParamJsonObject: {
    startDate: '',
    endDate: '',
    reportType: '',
    locationReport: [],
    location: ['BELL'],
    dataForm: 'daily',
    customer: '',
    ListFormula: []
  }
}

const validationRulesz = {
  SchedulerName: [
    {
      required: true,
      message: 'Name is required',
      trigger: 'change'
    }
  ],
  Day: [
    {
      required: true,
      message: 'Day is required',
      trigger: 'change'
    }
  ],
  Period: [
    {
      required: true,
      message: 'Schedule Period is required',
      trigger: 'change'
    }
  ],
  Email: [
    {
      required: true,
      message: 'Send To Email is required',
      trigger: 'change'
    }
  ],
  Subject: [
    {
      required: true,
      message: 'Subject is required',
      trigger: 'blur'
    }
  ],
  ParamJsonObject: {
    reportType: [
      {
        required: true,
        message: 'Report Type is required',
        trigger: 'change'
      }
    ],
    dataForm: [
      {
        required: true,
        message: 'Report Period is required',
        trigger: 'blur'
      }
    ],
    startDate: [
      {
        required: true,
        message: 'Start Period is required',
        trigger: 'blur'
      }
    ],
    endDate: [
      {
        required: true,
        message: 'End Period is required',
        trigger: 'blur'
      }
    ],
    location: [
      {
        required: false,
        message: 'Location is required',
        trigger: 'blur'
      }
    ],
    customer: [
      {
        required: false,
        message: 'Tenant is required',
        trigger: 'blur'
      }
    ],
    ListDceId: [
      {
        required: true,
        message: 'Device Group is required',
        trigger: 'blur'
      }
    ]
  }
}

export default {
  getEmptyData() {
    return emptyData
  },
  getValidationRule() {
    return validationRulesz
  }
}
